import { PqrTimeFilter } from '../../../../../shared/types/paramPqrTimes';

export const initialValues: PqrTimeFilter = {
    active: true,
    half: '',
    name: '',
    procedure: '',
    observation: '',
    receptionChannel: '',
    rule: '',
    subtypeDp: '',
    status: '',
    type: '',
    typeDay: '',
    endCreatedAt: undefined,
    startCreatedAt: undefined,
};
